import { jsx } from 'react/jsx-runtime';
import { SCHeaderButton } from '../styles.js';
import { SCMenuContainer, SCMenuToggleContainer } from './styles.js';
const Menu = () => {
  return /* @__PURE__ */jsx(SCMenuContainer, {
    children: /* @__PURE__ */jsx(SCMenuToggle, {})
  });
};
const SCMenuToggle = () => {
  return /* @__PURE__ */jsx(SCMenuToggleContainer, {
    children: /* @__PURE__ */jsx(SCHeaderButton, {
      children: /* @__PURE__ */jsx("span", {
        className: "svg-icon",
        children: /* @__PURE__ */jsx("svg", {
          width: "28",
          height: "28",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 3a1 1 0 000 2h20a1 1 0 100-2H2zm-1 9a1 1 0 011-1h20a1 1 0 110 2H2a1 1 0 01-1-1zm0 8a1 1 0 011-1h20a1 1 0 110 2H2a1 1 0 01-1-1z",
            fill: "#FFFFFF"
          })
        })
      })
    })
  });
};
export { Menu };